export default "__VITE_ASSET__c$qSDwhu__"